// extracted by mini-css-extract-plugin
module.exports = {"btn":"CommandActionButton_btn__XTTpq","icon":"CommandActionButton_icon__1IW_u"};